import { Reveal } from "@/components/site/Reveal";

const CHAPTERS = [
  { n: "01", title: "I come to you", body: "Full-time mobile. Your home, garage, garden, workplace or park — I bring the gym and the energy to your door." },
  { n: "02", title: "No gym anxiety", body: "For anyone afraid of gyms, or who's never known where to start. No mirrors, no crowds — just a space where you feel safe." },
  { n: "03", title: "Adaptable to anyone", body: "Any level, any body, any ability. I read each person and design a session around what you can do today." },
  { n: "04", title: "Train to feel good", body: "This isn't about competitions or looking a certain way. It's about strength, health and feeling young at any age." },
];

export const Manifesto = () => (
  <section id="approach" className="py-24 md:py-32 bg-[#0F172A]">
    <div className="mx-auto max-w-7xl px-5 md:px-10">
      <Reveal>
        <span className="font-mono-label text-[11px] text-[#FACC15]">The MyPT way</span>
        <h2 className="font-display font-bold text-4xl sm:text-5xl lg:text-6xl mt-4 max-w-3xl">
          A brand of one, <span className="text-[#FACC15]">built around you.</span>
        </h2>
      </Reveal>

      <div className="mt-16 divide-y divide-white/10 border-t border-white/10">
        {CHAPTERS.map((c, i) => (
          <Reveal key={c.n} delay={i * 0.06}>
            <div
              data-testid={`manifesto-${c.n}`}
              className="group grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-8 py-8 md:py-12 items-start"
            >
              <span className="md:col-span-2 font-display font-bold text-5xl md:text-7xl text-stroke-yellow group-hover:text-[#FACC15] transition-colors duration-500">
                {c.n}
              </span>
              <h3 className="md:col-span-4 font-display font-bold text-2xl md:text-4xl">{c.title}</h3>
              <p className="md:col-span-6 text-[#94A3B8] text-base md:text-lg leading-relaxed">{c.body}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
